import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAccountReadContext } from '@context/AccountContextContext'

import { Body1, Heading3 } from '@ui/Typography'
import { Button } from '@ui/components/Button'

import styles from './DeclinedClassificationTest.module.scss'

interface Props {
  handleOkOnClick: () => void
}

export const DeclinedClassificationTest: React.FC<Props> = ({ handleOkOnClick }) => {
  const { account } = useAccountReadContext()

  const { t } = useTranslation()

  return (
    <div className={styles.card}>
      <Heading3>{t('Profile.Classification test unsuccessful!')}</Heading3>
      <Body1 isParagraph>
        {t(
          'Profile.Thank you for submitting your application to be re-classified as a Professional Client',
          { name: account?.classification.name }
        )}
      </Body1>
      <Button.Secondary size='lg' onClick={handleOkOnClick}>
        {t('OK')}
      </Button.Secondary>
    </div>
  )
}
